/**
 * Backlog tab — filter defaults (values are ids where applicable, aligned with work items filters).
 */

export const BACKLOG_FILTER_DEFAULT = {
  search: "",
  status: "",
  priority: "",
  assignee: "",
};
